import { useSchoolSettings, getSchoolSettings } from "./schoolSettings";

// Currency symbol comes from school settings; the underlying fetch is cached
// and shared with the other school-settings consumers.
export const getCurrency = async () => (await getSchoolSettings()).currency || "";

/** React hook: returns the school's currency symbol ("" until loaded / when unset). */
export const useCurrency = () => useSchoolSettings().currency || "";

/** Formats an amount with the school currency, e.g. "PKR 12,500" (or "12,500" when no currency set). */
export const formatMoney = (value, currency, opts = {}) => {
  const num = Number(value) || 0;
  const formatted = num.toLocaleString(undefined, opts);
  return currency ? `${currency} ${formatted}` : formatted;
};
